import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { I18nService } from '@app/core/i18n.service';
import { environment } from '@env/environment';

/*
 * A locale selector component that pulls the supported locales from the environment file,
 * and allows the user to change the locale used by the i18n service and set in local storage.
 * Optional Output: emits the locale to be used by the parent component.
 * Optional Input: overrides the supported locales for the selector.
 */
@Component({
    selector: 'app-locale-select',
    templateUrl: 'locale-select.component.html',
    styleUrls: ['locale-select.component.scss']
})
export class LocaleSelectComponent implements OnInit {

    @Input() showIcon!: boolean;

    @Input() localesIds: string[] = []

    localesListMap: Map<string, string> = new Map<string, string>()

    constructor(protected i18nService: I18nService) {
        /** add list of locales */
        this.localesListMap.set('en-ca', 'English')
        this.localesListMap.set('fr-ca', 'Français')
    }
    
    ngOnInit(): void {
        /** change language */
        this.i18nService.selectedLocaleId$.subscribe(selectedLocaleId => {
            const selectedLocaleIdPath = `/${selectedLocaleId.toLocaleLowerCase()}`
            /** local */
            const isLocalEnvironment: boolean = environment.local            
            if(isLocalEnvironment || location.pathname.toLocaleLowerCase().substring(0, selectedLocaleIdPath.length) === selectedLocaleIdPath) {
                return
            }
            const effectivePathname = `${selectedLocaleIdPath}${location.pathname.substring(selectedLocaleIdPath.length)}`
            location.href = `${location.origin}${effectivePathname}${location.search}`;
        })
    }

    /**
     * 
     * @param matSelectChange 
     */
    onChange(matSelectChange: MatSelectChange) {
        const selectedLocaleId = matSelectChange.value
        this.i18nService.selectedLocaleId = selectedLocaleId.toLocaleLowerCase()
    }
}